import { getCountryConfig } from 'lib/constants/countryconfig'
import { parseLocale } from 'lib/constants/localization'
import _useTranslation from 'lib/hooks/_useTranslation'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { ButtonText } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import styled from 'styled-components'

const LegalLinksContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 7.5px;
    max-width: 320px;
    padding-top: 30px;
    p {
        word-break: break-word;
        :hover {
            color: ${theme.colors.deepSeaBlue};
        }
    }
`

const LegalPagesFooter = () => {
    const { locale } = useRouter()
    const parsedLocale = parseLocale(locale)
    const { legalLinks } = getCountryConfig(parsedLocale.countryCode)
    const { t: tCommon } = _useTranslation('common')

    return (
        <LegalLinksContainer>
            {legalLinks.map(({ path, text }) => (
                <Link href={path} key={text}>
                    <ButtonText fontFamily="var(--font-inter)" fontWeight={400} color={theme.colors.grayScaleSecondary}>
                        {tCommon(text)}
                    </ButtonText>
                </Link>
            ))}
        </LegalLinksContainer>
    )
}

export default LegalPagesFooter
